const mutable = val => val;
export { mutable };